import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/i18n";

const IMGS = [IMAGES.jobgrid, IMAGES.scrollstory, IMAGES.slackr, IMAGES.talenhub];

export default function Portfolio() {
  const { t } = useLang();
  const projects = t.portfolio.projects;

  return (
    <section id="work" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <Reveal><Overline>{t.portfolio.overline}</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-head font-bold tracking-tighter text-ink text-[clamp(2.25rem,5vw,4.5rem)] leading-[0.95] mt-5">
                {t.portfolio.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-base md:text-lg text-ink-2 leading-relaxed">{t.portfolio.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {projects.map((p, i) => (
            <Reveal
              key={p.name}
              delay={(i % 2) * 0.08}
              className={`group relative rounded-2xl border border-line hover:border-line-hover overflow-hidden bg-bg-2/50 transition-colors duration-500 ${
                i % 2 === 1 ? "md:mt-16" : ""
              }`}
              data-testid={`project-card-${i}`}
            >
              <div className="relative h-64 md:h-80 overflow-hidden">
                <img
                  src={IMGS[i]}
                  alt={p.name}
                  className="h-full w-full object-cover opacity-95 group-hover:opacity-100 group-hover:scale-105 transition-[opacity,transform] duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-bg-2 via-bg-2/20 to-transparent" />
                <div className="absolute top-6 left-6 font-mono text-xs tracking-widest uppercase text-ink bg-bg/60 backdrop-blur-md border border-line rounded-full px-4 py-1.5">
                  {p.cat}
                </div>
                <div className="absolute top-6 right-6 h-11 w-11 rounded-full bg-bg/70 backdrop-blur-md group-hover:bg-brand flex items-center justify-center border border-line group-hover:border-brand transition-colors duration-500">
                  <ArrowUpRight className="h-5 w-5 text-ink group-hover:text-white transition-colors duration-500" />
                </div>
              </div>
              <div className="p-8 md:p-10">
                <h3 className="font-head font-bold text-ink text-3xl md:text-4xl tracking-tight">{p.name}</h3>
                <p className="text-ink-2 leading-relaxed mt-4">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
